import React, { useEffect } from "react";
import { Grid, List, ListItem, ListItemText, Typography } from "@mui/material";
import { Wrapper } from "../common/component/layout";
import { Link } from "react-router-dom";

const PrivacyMobile = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <Wrapper>
      <Grid
        container
        direction="column"
        gap={6}
        sx={{
          padding: {
            xs: "50px 0px",
            sm: "50px 50px",
            md: "50px 80px",
          },
        }}
      >
        <Grid item>
          <Typography variant="h4">Privacy Policy For InspectFleet </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">Last updated: April 10, 2025</Typography>
        </Grid>
        <Grid item container direction="column" gap={2}>
          <Typography variant="body1">
            InspectFleet provides mobile application services.
          </Typography>
          <Typography variant="body1">
            This page informs you of our policies regarding the collection, use
            and disclosure of personal data when you use our service and of the
            choices you have associated with this data.
          </Typography>
        </Grid>

        <Grid item container direction="column" gap={5}>
          <Typography variant="h5">
            Collection and usage Your Personal Data
          </Typography>

          <Typography variant="body1">
            We collect several types of information for various purposes in
            order to provide and improve our service to you.
          </Typography>
        </Grid>
        <Grid item container direction="column" gap={2}>
          <Typography variant="h6">Types of Data Collected</Typography>
          <Typography variant="body1">Personal Data</Typography>
          <Typography variant="body1">
            While using Our Service, We may ask You to provide certain personal
            identifiable information which will be strictly used only to contact
            or identify You. These information includes the following:
          </Typography>
          <List
            sx={{
              listStyleType: "disc",
              paddingLeft: "20px",
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText primary={<Typography>Email address</Typography>} />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={<Typography>First name and last name</Typography>}
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText primary={<Typography>Phone number</Typography>} />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText primary={<Typography>Username</Typography>} />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText primary={<Typography>Usage Data</Typography>} />
            </ListItem>
          </List>
        </Grid>
        <Grid item container direction="column" gap={2}>
          <Typography variant="h6">Usage Data</Typography>

          <Typography variant="body1">
            We may also collect information that your device sends when you use
            our service or when you access the service by or through a mobile
            device (“Usage Data”). This Usage Data may include information such
            as:
          </Typography>
          <List
            sx={{
              listStyleType: "disc",
              paddingLeft: "20px",
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText primary={<Typography>Crash logs</Typography>} />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText primary={<Typography>Diagnostics</Typography>} />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={<Typography>Other app performance data</Typography>}
              />
            </ListItem>
          </List>
        </Grid>
        <Grid item container direction="column" gap={2}>
          <Typography variant="h6">
            Information Collected while Using the Application
          </Typography>
          <Typography variant="body1">
            While using Our Application, in order to provide features of Our
            Application, We may collect, with Your prior permission:
          </Typography>
          <List
            sx={{
              listStyleType: "disc",
              paddingLeft: "20px",
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <Typography>
                    Pictures and other information from your Device's camera and
                    photo library
                  </Typography>
                }
              />
            </ListItem>
          </List>
          <Typography variant="body1">
            We use this information to provide features of Our Service, to
            improve and customize Our Service, and to help monitor the condition
            of assets, enhance compliance, and improve operational efficiency.
            The information may be uploaded to the Company's servers and/or a
            Service Provider's server or it may be simply stored on Your device.
          </Typography>
          <Typography variant="body1">
            You can enable or disable access to this information at any time,
            through Your Device settings.
          </Typography>
        </Grid>
        <Grid item container direction="column" gap={2}>
          <Typography variant="h6">Personal Data usage</Typography>
          <Typography variant="body1">
            The Company may use Personal Data for the following purposes:
          </Typography>
          <List
            sx={{
              listStyleType: "disc",
              paddingLeft: "20px",
              // paddingBottom: '10px',
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <Typography>
                    <Typography component="span" fontWeight="500">
                      To provide and maintain:
                    </Typography>
                    &nbsp;our Service, including to monitor the usage of our
                    Service.
                  </Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <Typography>
                    <Typography component="span" fontWeight="500">
                      To manage Your Account:
                    </Typography>
                    &nbsp;to manage Your registration as a user of the Service.
                    The Personal Data You provide can give You access to
                    different functionalities of the Service that are available
                    to You as a registered user.
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <Typography>
                    <Typography component="span" fontWeight="500">
                      To provide You:
                    </Typography>
                    &nbsp;news and general information about other services, and
                    You have opted not to receive such information.
                  </Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <Typography>
                    <Typography component="span" fontWeight="500">
                      To detect, prevent and address technical issues
                    </Typography>
                  </Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <Typography>
                    <Typography component="span" fontWeight="500">
                      For other purposes:
                    </Typography>
                    &nbsp;We may use Your information for other purposes, such
                    as data analysis, identifying usage trends and to evaluate
                    and improve our Service, marketing, and Your experience.
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </Grid>

        <Grid item container direction="column" gap={2}>
          <Typography variant="h6">Transfer of Data</Typography>
          <Typography variant="body1">
            Your information, including Personal Data, may be transferred to —
            and maintained on — computers located outside of Your state,
            province, country, or other governmental jurisdiction where the data
            protection laws may differ from those from Your jurisdiction.
          </Typography>
          <Typography variant="body1">
            Your consent to this Privacy Policy followed by Your submission of
            such information represents Your agreement to that transfer.
          </Typography>
          <Typography variant="body1">
            InspectFleet will take all steps reasonably necessary to ensure that
            Your data is treated securely and in accordance with this Privacy
            Policy and no transfer of Your Personal Data will take place to an
            organization or a country unless there are adequate controls in
            place including the security of Your data and other personal
            information.
          </Typography>
        </Grid>
        <Grid item container direction="column" gap={2}>
          <Typography variant="h5">Disclosure of Data</Typography>

          <Typography variant="body1">
            We do not share your personal information or data with third parties
            outside of InspectFleet. The data we collect is solely for the
            purposes of providing and improving our Service.
          </Typography>
        </Grid>
        <Grid container direction={"column"} gap={2}>
          <Typography variant="h6">Data Protection</Typography>
          <Typography variant="body1">
            The security of Your Personal Data is important to Us, but remember
            that no method of transmission over the Internet, or method of
            electronic storage is 100% secure. While We strive to use
            commercially acceptable means to protect Your Personal Data, We
            cannot guarantee its absolute security.
          </Typography>
        </Grid>
        <Grid item container direction="column" gap={2}>
          <Typography variant="h6"> Data Retention</Typography>
          <Typography variant="body1">
            InspectFleet will retain Your Personal Data only for as long as is
            necessary for the purposes set out in this Privacy Policy. We will
            retain and use Your Personal Data to the extent necessary to comply
            with our legal obligations (for example, if we are required to
            retain your data to comply with applicable laws), resolve disputes,
            and enforce our legal agreements and policies.
          </Typography>
          <Typography variant="body1">
            InspectFleet will also retain Usage Data for internal analysis
            purposes. Usage Data is generally retained for a shorter period of
            time, except when this data is used to strengthen the security or to
            improve the functionality of Our Service, or We are legally
            obligated to retain this data for longer time periods.
          </Typography>
        </Grid>
        <Grid item container direction="column" gap={2}>
          <Typography variant="h6">Data Access and Control</Typography>
          <Typography variant="body1">
            You have the right to delete or request that We assist in deleting
            the Personal Data that We have collected about You.
          </Typography>
          <Typography variant="body1">
            Our Service may give You the ability to delete certain information
            about You from within the Service.
          </Typography>
          <Typography variant="body1">
            You may update, amend, or delete Your information at any time by
            contacting Us to request access to, correct, or delete any personal
            information that You have provided to Us.
          </Typography>
          <Typography variant="body1">
            Please note, however, that We may need to retain certain information
            when we have a legal obligation or lawful basis to do so.
          </Typography>
        </Grid>

        <Grid item container direction="column" gap={2}>
          <Typography variant="h5">Service Providers</Typography>
          <Typography variant="body1">
            We may employ third-party companies and individuals to facilitate
            our service (“service providers”), provide the service on our
            behalf, perform services related to the service or help us analyze
            how our service is used.
          </Typography>
          <Typography variant="body1">
            These third parties have access to your Personal Data only to
            perform these tasks on our behalf and are obligated not to disclose
            or use it for any other purpose.
          </Typography>
        </Grid>
        <Grid item container direction="column" gap={2}>
          <Typography variant="h6">Links to Other Sites</Typography>
          <Typography variant="body1">
            Our Service may contain links to other websites that are not
            operated by Us. If You click on a third-party link, You will be
            directed to that third party's site. We strongly advise You to
            review the Privacy Policy of every site You visit.
          </Typography>
          <Typography variant="body1">
            We have no control over and assume no responsibility for the
            content, privacy policies, or practices of any third-party sites or
            services.
          </Typography>
        </Grid>
        <Grid container direction={"column"} gap={2}>
          <Typography variant="h6">Commitment to Children's Privacy</Typography>
          <Typography variant="body1">
            Our Service does not address anyone under the age of 18. We do not
            knowingly collect personally identifiable information from anyone
            under the age of 18. If You are a parent or guardian and You are
            aware that Your child has provided Us with Personal Data, please
            contact Us. If We become aware that We have collected Personal Data
            from anyone under the age of 18 without verification of parental
            consent, We take steps to remove that information from Our servers.
          </Typography>
          <Typography variant="body1">
            If We need to rely on consent as a legal basis for processing Your
            information and Your country requires consent from a parent, We may
            require Your parent's consent before We collect and use that
            information.
          </Typography>

          <Typography variant="body1">
            We have no control over and assume no responsibility for the
            content, privacy policies, or practices of any third-party sites or
            services.
          </Typography>
        </Grid>

        <Grid item container direction={"column"} gap={2}>
          <Typography variant="h6">Changes to this Privacy Policy</Typography>
          <Typography variant="body1">
            We may update Our Privacy Policy from time to time. We will notify
            You of any changes by posting the new Privacy Policy on this page.
          </Typography>
          <Typography variant="body1">
            We will let You know via email and/or a prominent notice on Our
            Service, prior to the change becoming effective and update the "Last
            updated" date at the top of this Privacy Policy.
          </Typography>
          <Typography variant="body1">
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </Typography>
        </Grid>

        <Grid item container direction="column" gap={2}>
          <Typography variant="h6">Changes to this Privacy Policy</Typography>
          <Typography variant="body1">
            If you have any questions about this Privacy Policy, You can contact
            us:
          </Typography>
          <List
            sx={{
              listStyleType: "disc",
              paddingLeft: "20px",
            }}
          >
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <Typography>
                    By email:
                    <Typography
                      component={Link}
                      sx={{
                        textDecoration: "none",
                        color: "primary.light",
                      }}
                      to={"mailto:inspectfleet@gmail.com"}
                      target="_top"
                    >
                      inspectfleet@gmail.com
                    </Typography>
                  </Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <Typography>
                    By visiting this page on our website: &nbsp;
                    <Typography
                      component={Link}
                      sx={{
                        textDecoration: "none",
                        color: "primary.light",
                      }}
                      to={"https://inspectfleet.com/#contact"}
                    >
                      contact us
                    </Typography>
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default PrivacyMobile;
